"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var FirstLineTextContainer_1 = require("./FirstLineTextContainer");
var MessageAdListItemIconBar_1 = require("./MessageAdListItemIconBar");
var PersonaCheckboxContainer_1 = require("./PersonaCheckboxContainer");
var TwistyContainer_1 = require("./TwistyContainer");
var mobx_react_1 = require("mobx-react");
var owa_messagead_strings_1 = require("owa-strings/owa-messagead-strings");
var React = require("react");
var styles = require('./MessageAdListItem.scss');
var classNames = require('classnames/bind').bind(styles);
var SingleLineViewFirstColumn = /** @class */ (function (_super) {
    tslib_1.__extends(SingleLineViewFirstColumn, _super);
    function SingleLineViewFirstColumn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SingleLineViewFirstColumn.prototype.render = function () {
        var isReadingPanePositionOff = true;
        var adTextClass = classNames(styles.adText, styles.adTextReadingPaneOff);
        return (React.createElement("div", { className: styles.firstColumn },
            React.createElement(TwistyContainer_1.default, { isReadingPanePositionOff: isReadingPanePositionOff }),
            React.createElement(PersonaCheckboxContainer_1.default, { isSelected: this.props.isSelected, isUnread: this.props.isUnread, isReadingPanePositionOff: isReadingPanePositionOff }),
            React.createElement("span", { className: classNames(adTextClass, 'fbAdLink') }, owa_messagead_strings_1.default.adTextSubjectLabel),
            React.createElement(FirstLineTextContainer_1.default, { firstLineText: this.props.firstColumnText, isUnread: this.props.isUnread, isReadingPanePositionOff: isReadingPanePositionOff }),
            React.createElement(MessageAdListItemIconBar_1.default, { adChoiceUrl: this.props.iconBarUrl, adId: this.props.adId })));
    };
    SingleLineViewFirstColumn = tslib_1.__decorate([
        mobx_react_1.observer
    ], SingleLineViewFirstColumn);
    return SingleLineViewFirstColumn;
}(React.Component));
exports.default = SingleLineViewFirstColumn;
//# sourceMappingURL=SingleLineViewFirstColumn.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/view/owa-mail-messagead-list-view/lib/components/SingleLineViewFirstColumn.js
// module id = 5997
// module chunks = 67